// export const CORE_API_ENDPOINT = 'https://www.rmbainisys.com/vms'
// export const CORE_API_ENDPOINT = `https://dtacbainisys.com/core`
// http://localhost:2000
// http://10.0.30.19:1000/vms
//https://profilecenter.rmbainisys.com/api

// export const CORE_API_ENDPOINT = 'http://localhost:2001'
// export const CORE_API_ENDPOINT = 'https://profilecenter.rmbainisys.com/api'

//10.0.30.9
export const CORE_API_ENDPOINT = '/api'
    


// WEBPACK FOOTER //
// ./src/lib/api.js